import React from 'react';
import styled from 'styled-components/macro';
import { connect } from 'react-redux';
import { applicationPropTypes } from '../../utils/proptypes';
import applicationListSelectors from '../../modules/application/list/applicationListSelectors';
import PromotionBannerWrapper from '../PromotionBanner/PromotionBannerWrapper';

const $OverlayContainer = styled.div`
  position: fixed;
  z-index: 1000;
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
`;

const Overlay = ({ application }) => {
  return (
    <$OverlayContainer>
      <PromotionBannerWrapper />
    </$OverlayContainer>
  );
};

Overlay.propTypes = {
  application: applicationPropTypes,
};

const mapStateToProps = state => ({
  application: applicationListSelectors.selectApplication(state),
});

export default connect(mapStateToProps)(Overlay);
